var map = {
	"./1676112946540_MargaritaPizza.jpg": 5192,
	"./1676113652938_AlTonno2.jpg": 987,
	"./1676114077415_PastaCurryChicken.jpg": 9735,
	"./1676114332400_PastaCarbonara.jpg": 486,
	"./1676114332400_PastaCarbonara.webp": 7802,
	"./1676114569876_PastaArrabbiata.jpg": 3809,
	"./1676114569876_PastaArrabbiata.webp": 1129,
	"./1676114633068_Coca-Cola.jpg": 6686,
	"./1676114731950_OrangeJuice.jpg": 1513,
	"./1676114826095_Coffee.jpg": 2900,
	"./1676114867327_Water.jpg": 7072,
	"./1676115008760_TunaPizza.jpg": 5848,
	"./1676115611098_Hamburger.jpg": 9591,
	"./1676115698924_BBQ.jpg": 5208,
	"./1676115908222_CheeseBurger.jpg": 9970,
	"./1676116026212_BaconChees.jpg": 1080,
	"./1676116978549_SerbianSalad.jpg": 5527,
	"./1676117095965_SerbianSalad.jpg": 6920,
	"./1676118039911_CeaserSalad.jpg": 4103,
	"./1676118151668_waldorfsalad.jpg": 3031,
	"./1676118210009_GreekSalad.jpg": 1395,
	"./1676118989322_ChocolateCake.jpg": 433,
	"./1676119135172_baklava.jpg": 4952,
	"./1676119197013_Pancakes.jpg": 1692,
	"./1676119344621_plazmaCake.jpg": 8922,
	"./1676119484842_apple-pie.jpg": 6770,
	"./1676148329394_mediterranean-pizza.jpg": 8051,
	"./1676148401470_Pepperoni-Pizza.jpg": 6708,
	"./1676148449501_Tropical-Chicken.jpg": 6804,
	"./1676148982902_Fettuccine-Bolognese.jpg": 8188,
	"./1676149017387_Fettuccine-Alfredo.jpg": 1228,
	"./1676149145340_Fettuccine-Alfredo.jpg": 1649,
	"./1676149511970_antipastosalad.jpg": 8237,
	"./1676149607072_grilled-chicken-salad.jpg": 8131,
	"./1676149657059_Chef-Salad.jpg": 1548,
	"./1676150093133_Nutella-Cheesecake.jpg": 7940,
	"./1676150093133_Nutella-Cheesecake.webp": 5468
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6025;